'use client';

import { Accordion } from './Accordion';
import { AccordionContent } from './_components/AccordionContent';
import { AccordionTitle } from './_components/AccordionTitle';

type AccordionCompoundType = typeof Accordion & {
  Title: typeof AccordionTitle;
  Content: typeof AccordionContent;
};

const AccordionCompound = Accordion as AccordionCompoundType;

AccordionCompound.Title = AccordionTitle;
AccordionCompound.Content = AccordionContent;

export { AccordionCompound as Accordion };
